import { render, staticRenderFns } from "./AddServiceCatalogItemModal.vue?vue&type=template&id=32bddabe&scoped=true&"
import script from "./AddServiceCatalogItemModal.vue?vue&type=script&lang=ts&"
export * from "./AddServiceCatalogItemModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bddabe",
  null
  
)

export default component.exports